import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Overflow14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      d='M3 7C3 7.55228 2.55228 8 2 8C1.44772 8 1 7.55228 1 7C1 6.44772 1.44772 6 2 6C2.55228 6 3 6.44772 3 7Z'
      fill='currentColor'
    />
    <path
      d='M7 8C7.55228 8 8 7.55228 8 7C8 6.44772 7.55228 6 7 6C6.44772 6 6 6.44772 6 7C6 7.55228 6.44772 8 7 8Z'
      fill='currentColor'
    />
    <path
      d='M12 8C12.5523 8 13 7.55228 13 7C13 6.44772 12.5523 6 12 6C11.4477 6 11 6.44772 11 7C11 7.55228 11.4477 8 12 8Z'
      fill='currentColor'
    />
  </Svg>
);

Overflow14.displayName = 'Overflow14';
export default Overflow14;
